// What a wash costs for a car of a given size: the one rule, shared by Book
// & pay ("Mini Valet for your Grey Volvo XC90: £109", step-book) and the home
// page's reg-price fold (pages/home/sections/hero/reg), so the two can never
// say different numbers. A Large car is the wash plus the large-car
// surcharge (+£20 since 19 Oct 2026, docs/DECISIONS.md); small to medium is
// the wash. Both amounts come from the services table, in pence; nothing
// here knows a price.
//
// Pure, pinned by car-price.test.mjs.

// "£69" or "£12.50" (as the server writes gwmc:prices) -> pence; null for
// anything that is not a positive amount.
export const pence = price => {
  const n = Number(String(price ?? '').replace(/[^0-9.]/g, ''))
  return n > 0 ? Math.round(n * 100) : null
}

// null when it cannot be priced: no wash price, or a Large car and no
// surcharge yet (never the wash alone passed off as the Large price).
export const washPenceForSize = (washPence, largePence, size) => {
  if (!(washPence > 0)) return null
  if (size !== 'large') return washPence
  return largePence > 0 ? washPence + largePence : null
}

// 10900 -> "£109", 1250 -> "£12.50", as the site writes prices.
export const poundsText = p => (p > 0 ? `£${(p / 100).toFixed(p % 100 ? 2 : 0)}` : null)
